var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTownHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 29.38 22.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #8b8c9e;\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 29.38,
    height: 22.01
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.5,10.28L7.59,5.29l7.09,4.99v11.23H.5V10.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.69,5.49L21.78,.5l7.09,4.99V21.51H14.69V5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.21,11.48H3.67v2.37h2.54v-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.21,16.4H3.67v5.11h2.54v-5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.62,11.48h-2.54v2.37h2.54v-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.62,16.4h-2.54v2.37h2.54v-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.24,11.48h-2.54v2.37h2.54v-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.24,16.4h-2.54v5.11h2.54v-5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.66,11.48h-2.54v2.37h2.54v-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.24,6.56h-2.54v2.37h2.54v-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.66,6.56h-2.54v2.37h2.54v-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.66,16.4h-2.54v2.37h2.54v-2.37Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTownHome);
export default __webpack_public_path__ + "static/media/TownHome.d9108df2.svg";
export { ForwardRef as ReactComponent };